import View from './View';

export { default as View, getRecordingButtonStyles } from './View';

export default View;
